const getSize = (size, percent) => (percent * size) / 100

export const getPostitions = (country) => {
  let mapImg = document.getElementById('operation-map')
    , marker = document.getElementById(country.id)
  let { offsetHeight, offsetWidth } = mapImg

  if (country.left && marker !== null) marker.style.left = `${getSize(offsetWidth, country.left)}px`
  if (country.right && marker !== null) marker.style.right = `${getSize(offsetWidth, country.right)}px`
  if (country.top && marker !== null) marker.style.top = `${getSize(offsetHeight, country.top)}px`
  if (country.bottom && marker !== null) marker.style.left = `${getSize(offsetHeight, country.bottom)}px`
  if (marker !== null) marker.style.opacity = 1
}